import {Enum} from 'enumify';

class FontLoaderFonts extends Enum {};

FontLoaderFonts.initEnum([
    'Carlito', 'Consolas', 'ComicSansMS', 'Impact', 'CourierPrime', 'OldStandard', 'Myriad', 'TrebuchetMS', 'Verdana', 'MuseoRegular'
]);

export default FontLoaderFonts;
